@for(key of keypadKeys; track key){
    <button mat-button [disabled]="isAlreadyFloat(key)" class="keypad-button" [ngClass]="{'tw-pointer-events-none tw-opacity-60':this.isAlreadyFloat(key)}" (click)="pressKey(key)" [style.--keyboard-font-size]="keyboardFontSize + 'px'">{{key}}</button>
}
<button mat-button class="keypad-button" (mousedown)="clickEnabled.set(true)" (click)="clickEnabled()&&pressKey('back')" tilbyGestures (longPress)="clear()" [style.--keyboard-font-size]="keyboardFontSize + 'px'">
    <mat-icon class="tw-text-red-500 tw-m-0" fontIcon="backspace"/>
</button>
